require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('svg', Painter);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zrender/lib/svg/svg.js
// module id = jLnL
// module chunks = 0 1